<template>
  <div class="send-documents-wrapper">
    <div class="send-documents-title">
      {{ bypassDocuments ? 'Envio da selfie' : 'Envio de documentos' }}
    </div>
    <div class="send-documents-details">
      <div v-if="!isSmall" class="notification">
        <asset-v3 dir="icons" name="warning-circle-solid.svg"/>
        Esta etapa só pode ser realizada através do celular cadastrado.
      </div>
      <div v-if="!isSmall" class="send-documents-card">
        <div class="send-documents-card-title">
          <asset-v3 v-if="!isSmall" dir="icons" name="phone-small.svg"/>
          Para prosseguir, acesse o link enviado para o celular:
        </div>
        <div class="send-documents-card-value">{{ secretPhone }}</div>
      </div>
      <div class="disclaimer">
        <div>
          {{ disclaimerDescription }}
        </div>
        <div v-if="!isSmall">
          Está com problemas para acessar o link? Entre em contato no email
          <span>atendimento@parcelex.com.br</span>
        </div>
      </div>
      <div v-if="isSmall">
        <a :href="goToSendDocumentsPage()">
          <Button
            :text="bypassDocuments ? 'Enviar selfie' : 'Enviar Documentos'"
            class="send-documents-button"
            :bold="true"
            :action="() => {}"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import AssetV3 from '@/components/common/AssetV3.vue';
import Button from '@/components/common/Button.vue';
import UtilMixin from '@/mixins/util';

export default {
  components: {
    AssetV3,
    Button,
  },
  props: {
    phone: {
      type: String,
    },
    onboardingToken: {
      type: String,
    },
    transactionId: {
      type: String,
    },
    bypassDocuments: {
      type: Boolean,
    },
  },
  mixins: [UtilMixin],
  methods: {
    goToSendDocumentsPage() {
      return `/onboarding?onboardingToken=${
        this.onboardingToken
      }&transactionId=${
        this.transactionId
      }&f=true`;
    },
  },
  computed: {
    secretPhone() {
      const phoneStart = this.phone?.slice(0, 2);
      const phoneEnd = this.phone?.slice(-4);

      return `(${phoneStart}) ***** ${phoneEnd}`;
    },
    isSmall() {
      return this.isMobile();
    },
    disclaimerDescription() {
      const defaultText = 'Para realizar sua primeira compra com o Parcelex é necessário enviar uma foto do seu documento de identificação';
      const bypassText = 'Para realizar sua primeira compra com o Parcelex é necessário enviar uma selfie';
      const finalText = this.bypassDocuments ? bypassText : defaultText;

      return `${finalText}. Você só precisa fazer isso uma vez.`;
    },
  },
};
</script>

<style lang="scss" scoped>
.send-documents-title {
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  color: #212B36;
}
.send-documents-details {
  margin-top: 26px;
}
.send-documents-details .notification {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #A87F0B;
  display: flex;
  align-items: center;
}
.send-documents-details-title {
  font-size: 14px;
  line-height: 20px;
  color: #212B36;
  margin-bottom: 8px;
}
.send-documents-details-value {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #212B36;
}
.send-documents-card {
  background: #F4F6F8;
  border-radius: 8px;
  padding: 20px;
  margin-top: 12px;
  margin-bottom: 8px;
}
.send-documents-card-title {
  display: flex;
  align-items: center;
}
.send-documents-card-value {
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  color: #212B36;
  margin-left: 26px;
  margin-top: 8px;
}
.resend-link {
  font-size: 16px;
  line-height: 24px;
  color: #36A3CA;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
}
.disclaimer>div {
  font-size: 16px;
  line-height: 24px;
  color: #637381;
  margin-top: 16px;
}
.disclaimer>div span {
  font-weight: bold;
}
@media (max-width: $sm) {
  .send-documents-wrapper{
    width: unquote("Calc(100vw - 48px) !important");
  }
  .send-documents-title {
    margin-left: 55px;
    margin-top: 5px;
  }
  .send-documents-card-title {
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    color: #637381;
  }
  .send-documents-card-value {
    margin-left: unset;
  }
  .disclaimer>div {
    font-size: 18px;
    line-height: 24px;
    color: #212B36;
    padding-top: 12px;
  }
}
</style>
<style>
.send-documents-details>div:first-child img {
  margin-right: 8px;
}
.send-documents-card-title img {
  margin-right: 14px;
}
.send-documents-button .button {
  display: block;
  margin-left: 0;
  margin-top: 20px;
  width: auto;
  padding: 12px 0px;
  font-size: 18px;
  line-height: 24px;
}
</style>
